import { Tooltip, IconButton } from "@mui/material";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const defaultRender = (value) => (value ? value : "--");

const createMailCell = ({ handleOpen, handleDeleteOpen, handleViewOpen,t }) => {
  return [
    { title: t("senderName"), field: "senderUsername", render: defaultRender },
    { title: t("date/time"), field: "dateTime", render: (value) => (value ? new Date(value).toLocaleString() : "--"),},
    { title: t("subject"), field: "subject", render: defaultRender },
    { title: t("status"), field: "unread", render: (value) => (value ? t("unread") : t("read")) },

    { title: (<Tooltip title={t("writeaMail")}><IconButton sx={{p:0}} onClick={handleOpen}><AddCircleOutlineIcon sx={{ fontSize: "18px" }} /></IconButton></Tooltip>),
      field: "actions",
      render: (row) => (
        <>
          <Tooltip title={t("deleteMail")}><IconButton sx={{p:0.5}} onClick={() => handleDeleteOpen(row)}><DeleteOutlineOutlinedIcon sx={{ fontSize: "16px", color: "#D32F2F" }} /></IconButton></Tooltip>
          <Tooltip title={t("viewMail")}><IconButton sx={{p:0.5}} onClick={() => handleViewOpen(row)}><VisibilityOutlinedIcon sx={{ fontSize: "16px", color: "#1976D2" }} /></IconButton></Tooltip>
        </>
      ),
    },
  ];
};

export default createMailCell;
